<div class="wrapper">
  <div class="action-section flex flex-row-reverse my-[20px] w-full gap-[20px]">
    @if (canCreate) {
      <app-primary-button (click)="create()" class="!w-[150px]" data-testid="sample-create">Create</app-primary-button>
    }
    <div class="sample-filters flex flex-row gap-[20px] flex-1 mt-[7px]">
      <div class="search-section flex flex-1 flex-row gap-[10px] min-w-0">
        <form [formGroup]="searchForm" class="flex-1 min-w-0">
          <div class="search w-full">
            <mat-icon svgIcon="search"></mat-icon>
            <input
              class="search-input"
              data-testid="sample-search"
              formControlName="searchText"
              matInput
              placeholder="Search"
              />
            @if (searchForm?.controls?.searchText?.value) {
              <mat-icon (click)="clearSearch()" svgIcon="close"></mat-icon>
            }
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="list-section">
    <div class="sample-list-table flex flex-col gap-[40px]">
      @if (loading && !originalDataSource.length) {
        <div class="no-data text-type-8 mt-[80px]">Loading sample records&hellip;</div>
      }

      @if (!loading && loadError) {
        <div class="no-data text-type-8 mt-[80px]">{{ loadError }}</div>
      }

      @if (!loadError && dataSource?.length) {
        <div class="table-scroll-wrapper">
          <table [dataSource]="dataSource" class="mat-elevation-z8 table" mat-table>
            <ng-container matColumnDef="name">
              <th *matHeaderCellDef mat-header-cell>
                <span class="th-text">Sample Name</span>
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-8">{{ row?.name || '-' }}</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="labControlNumber">
              <th *matHeaderCellDef mat-header-cell>
                <span class="th-text">Lab Control #</span>
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.lab_control_number || '-' }}</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="fieldNumber">
              <th *matHeaderCellDef mat-header-cell>
                <span class="th-text">Field Number</span>
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.control_number || '-' }}</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="material">
              <th *matHeaderCellDef mat-header-cell>
                <span class="th-text">Material</span>
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.material_name || '-' }}</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="sampleType">
              <th *matHeaderCellDef mat-header-cell>
                <span class="th-text">Sample Type</span>
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.sample_type || '-' }}</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="sampleDate">
              <th *matHeaderCellDef mat-header-cell>
                <span class="th-text">Sample Date</span>
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.sample_date | date : 'MMM d, y' }}</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="source">
              <th *matHeaderCellDef mat-header-cell>
                <span class="th-text">Source</span>
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.source_value || '-' }}</div>
              </td>
            </ng-container>

            <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
            <tr
              data-testid="sample-record-row"
              (click)="rowClicked(row)"
              *matRowDef="let row; columns: displayedColumns"
              [class.highlighted-row]="row === selectedRow"
              mat-row
            ></tr>
          </table>
        </div>
      }

      @if (!loading && !loadError && !dataSource?.length) {
        <div class="no-data text-type-8 mt-[80px]">
          {{ originalDataSource.length ? 'No samples match your search.' : 'No samples for this project yet.' }}
        </div>
      }

      <app-paginator
        (pageChanged)="onPageChanged($event)"
        [itemsPerPage]="itemsPerPage"
        [maxVisiblePages]="5"
        [totalItems]="totalRecords"
        class="paginator"
      />
    </div>
  </div>
</div>
